import { usePlausibleTrackingInit } from "@/hooks/usePlausibleTracking";

/**
 * TrackingInithandler created to place Plausible init below ErrorBoundry while being above EkulturLoginHandler
 * @constructor
 */
const TrackingInitHandler = () => {
  usePlausibleTrackingInit();
  return null;
};
export default TrackingInitHandler;
